import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { ExtrasService } from "src/app/extras.service";
import { LatLngBounds } from "@agm/core";
import { FormControl, FormBuilder } from "@angular/forms";
import { Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { MessageService } from "src/app/injectable/message.service";
import { Area } from "src/app/model/area";
import { MatTabGroup } from "@angular/material/tabs";
import { MatDialog } from "@angular/material/dialog";
import { AdminService } from "src/app/injectable/admin.service";
import { AreaItem } from "../client-detail/area-item";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";

declare var google: any;

@Component({
  selector: "app-area-factory",
  templateUrl: "./area-factory.component.html",
  styleUrls: ["./area-factory.component.scss"],
})
export class AreaFactoryComponent implements OnInit {
  showingArea = false;
  query: string;
  featureCollection: any = [];
  map: any; // Reference alla mappa vera e propria
  selectedAreaGeoJson: any;
  bounds: LatLngBounds;
  loading = false;
  myControl = new FormControl();
  options: Area[] = [];
  filteredOptions: Observable<Area[]>;
  targetList: Array<any> = [];
  filterargs = null;

  @Output() areeChanged = new EventEmitter<any>();
  @Input() areaID;

  areaAutocompleteControl = new FormControl();
  areaFormGroup = this.fb.group({
    area: null,
  });

  availableAreas: any[];

  matTabs = [1, 2];
  @ViewChild("tabGroup", { static: false }) tabGroup: MatTabGroup;

  constructor(
    public extrasService: ExtrasService,
    private messageService: MessageService,
    private adminService: AdminService,
    private genericErrorModalService: GenericErrorModalService,
    private fb: FormBuilder,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.filteredOptions = this.areaFormGroup.get("area").valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
    this.adminService.getAllAreas().subscribe(
      (result) => {
        this.options = result;
        this.featureCollection = this.options;
        this.availableAreas = result
          .map((item) => {
            let areaItem: AreaItem;
            areaItem = {
              id: item.id,
              areaName: item.areaName,
              chosen: false,
              selected: false,
            };
            return areaItem;
          })
          .sort((a, b) => a.areaName.localeCompare(b.areaName));
      },
      (err) => {}
    );
    this.query = "";

    if (this.areaID != null) {
      this.adminService.getAreaDetail(this.areaID).subscribe((data) => {
        let areaItemTMP = {
          id: this.areaID,
          areaName: data["object"]["name"],
          chosen: true,
          selected: true,
        };
        this.targetList.push(areaItemTMP);
      });
    }
  }

  private _filter(value: string): Area[] {
    const filterValue = value;
    return this.options.filter((option) =>
      option.area.toLowerCase().includes(filterValue)
    );
  }

  searchArea() {
    this.filterargs = { areaName: this.query };
    this.tabGroup.selectedIndex = 0;
    this.tabGroup._tabs.toArray()[0].isActive = true;
  }

  onItemExplore(area) {
    this.loading = true;
    this.adminService.getAreaDetail(area.id).subscribe(
      (value) => {
        this.loading = false;
        this.selectedAreaGeoJson = value.object.geoArea;
        this.adjustBounds(this.selectedAreaGeoJson.geometry);
        this.showingArea = true;
      },
      (err) => {
        this.loading = false;
        this.genericErrorModalService.open(
          "Errore durante il caricamento della mappa",
          err
        );
      }
    );
  }

  onItemSelected(area) {
    if (this.targetList.length == 1) {
      this.openSingleAreaWarningDialog();
      return;
    }
    if (this.targetList.find((x) => x.id == area.id) == null) {
      this.targetList.push(area);
      this.targetList = this.targetList.sort((a, b) =>
        a.area > b.area ? 1 : -1
      );
      area.selected = true;
      this.areeChanged.emit(this.targetList);
    }
    this.tabGroup.selectedIndex = 1;
    this.tabGroup._tabs.toArray()[1].isActive = true;
  }

  onItemRemoveToTarget(area) {
    this.targetList = this.targetList.filter((item) => item.id != area.id);
    area.selected = false;
    this.areeChanged.emit(this.targetList);
  }

  styleFunc(feature) {
    return {
      clickable: false,
      fillColor: "rgba(0, 0, 0, 0.486)",
      strokeColor: "rgba(0, 0, 0, 0.400)",
      strokeWeight: 1,
    };
  }

  onMapReady(readyMap: any) {
    this.map = readyMap;
    readyMap.setOptions({
      draggable: false,
      fullscreenControl: false,
      draggableCursor: "",
    });
  }

  adjustBounds(geometry) {
    this.bounds = new google.maps.LatLngBounds();
    if (geometry.type == "Polygon") {
      for (const mm of geometry.coordinates[0]) {
        this.bounds.extend(new google.maps.LatLng(mm[1], mm[0]));
      }
      this.map.fitBounds(this.bounds);
    } else if (geometry.type == "MultiPolygon") {
      for (const polygon of geometry.coordinates) {
        for (const mm of polygon[0]) {
          this.bounds.extend(new google.maps.LatLng(mm[1], mm[0]));
        }
      }
      this.map.fitBounds(this.bounds);
    }
  }

  autocompleteDisplayWith(value: any): string {
    return value?.area;
  }

  openSingleAreaWarningDialog() {
    const dialogRef = this.dialog.open(SingleAreaWarningDialog);
  }
}

@Component({
  selector: "single-area-warning-dialog",
  templateUrl: "./single-area-warning-dialog.html",
})
export class SingleAreaWarningDialog {}
